<template>
    <!--
        Barras de señal de la conexión del puesto, visibles siempre.
        Un indicador que solo se asoma en la falla nadie sabe interpretarlo
        cuando por fin aparece. Estando siempre, la gente aprende a leerlo — y
        ante una queja de lentitud basta preguntar "¿cómo están las barras?".
        El texto solo se muestra cuando la conexión está mala: el usuario final
        no es técnico y no necesita leer nada mientras todo funcione.

        OJO con las etiquetas: van en `<span>` y NO en `<i>`. Este proyecto carga
        FontAwesome en su version SVG-con-JS, que recorre el DOM reemplazando las
        `<i>` que cree iconos — y se llevaba estas barras por delante.
    -->
    <div class="d-flex align-items-center mr-3" :title="titulo">
        <span class="d-inline-flex align-items-end" style="height: 16px;">
            <span v-for="n in 4" :key="n"
                  :class="n <= (nivel || 0) ? color : 'bg-dark'"
                  :style="estiloBarra(n)"></span>
        </span>
        <span v-if="nivel === 1" class="small font-weight-bold text-danger ml-1 d-none d-md-inline">
            Conexión inestable
        </span>
    </div>
</template>

<script>
import { estado } from "../../monitoring/calidadConexion";

/** Alto de cada barra en px, para que crezcan de izquierda a derecha. */
const ALTOS = [6, 9, 12, 15];

export default {
    name: "IndicadorConexion",

    computed: {
        nivel() {
            return estado.nivel;
        },

        color() {
            if (this.nivel === null) return 'bg-secondary';
            if (this.nivel <= 1) return 'bg-danger';
            if (this.nivel === 2) return 'bg-warning';
            return 'bg-success';
        },

        /** Frase en palabras, sin cifras: el detalle vive en los logs. */
        titulo() {
            if (this.nivel === null) return 'Midiendo la conexión…';
            if (this.nivel === 1) return 'La conexión de este equipo está presentando intermitencias';
            if (this.nivel === 2) return 'La conexión de este equipo está regular';
            return 'Conexión estable';
        },
    },

    methods: {
        estiloBarra(n) {
            const alcanzada = n <= (this.nivel || 0);

            // Las barras sin alcanzar se quedan tenues en vez de desaparecer,
            // para que el indicador no cambie de ancho al variar el nivel. Con
            // 0.25 la primera era practicamente invisible y parecia que solo
            // habia tres, asi que sube a 0.35 y las barras son mas anchas.
            return {
                display: 'inline-block',
                width: '4px',
                height: ALTOS[n - 1] + 'px',
                marginRight: n < 4 ? '2px' : '0',
                borderRadius: '1px',
                opacity: alcanzada ? '1' : '0.35',
            };
        },
    },
};
</script>
